"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getTreeAlterationSuit", {
  enumerable: true,
  get: function get() {
    return _treeAlterationSuit["default"];
  }
});
Object.defineProperty(exports, "getTreeAlterationSuitPackage", {
  enumerable: true,
  get: function get() {
    return _treeAlterationSuitPackage["default"];
  }
});
Object.defineProperty(exports, "getTreeChairCreation", {
  enumerable: true,
  get: function get() {
    return _treeChairCreation.getTreeChairCreation;
  }
});
Object.defineProperty(exports, "getTreeCreation", {
  enumerable: true,
  get: function get() {
    return _treeCreation["default"];
  }
});
exports.getTreeInverse = void 0;
Object.defineProperty(exports, "getTreeSofaCreations", {
  enumerable: true,
  get: function get() {
    return _treeSofaCreations.getTreeSofaCreations;
  }
});
exports.multipleQuestions = exports.hasMixedIdsAtHomeAndPackage = exports.hasCommonIdsAtHomeAndPackage = void 0;
var _treeCreation = _interopRequireDefault(require("./treeCreation"));
var _treeAlterationSuit = _interopRequireWildcard(require("./treeAlterationSuit"));
var _treeAlterationSuitPackage = _interopRequireDefault(require("./treeAlterationSuitPackage"));
var _treeSofaCreations = require("./treeSofaCreations");
var _treeChairCreation = require("./treeChairCreation");
var _tree = _interopRequireWildcard(require("./tree"));
var _treePackage = _interopRequireWildcard(require("./treePackage"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // i18next-extract-mark-ns-start Trees
var getTreeInverseWithoutSuit = function getTreeInverseWithoutSuit(t, process) {
  var treeInverseWithoutSuit = {};
  var tree = process === 'AT_HOME' ? (0, _tree["default"])(t) : (0, _treePackage["default"])(t);
  tree.forEach(function (cloth) {
    if (!cloth.typesOfWork) return;
    cloth.typesOfWork.forEach(function (typeOfWork) {
      if (!typeOfWork.problems) return;
      typeOfWork.problems.forEach(function (problem) {
        if (!problem.locations) return;
        problem.locations.forEach(function (location) {
          treeInverseWithoutSuit["".concat(cloth.slug, "_").concat(location.slug)] = location;
          if (!location.parts) return;
          location.parts.forEach(function (part) {
            treeInverseWithoutSuit["".concat(cloth.slug, "_").concat(part.slug)] = part;
          });
        });
      });
    });
  });
  return treeInverseWithoutSuit;
};
var getTreeInverse = exports.getTreeInverse = function getTreeInverse(t, process) {
  return _objectSpread(_objectSpread({}, getTreeInverseWithoutSuit(t, process)), (0, _treeAlterationSuit.getTreeAlterationSuitInverse)(t, process));
};
var multipleQuestions = exports.multipleQuestions = function multipleQuestions(t) {
  return {
    pocket: t('Combien de poches sont trouées ?'),
    button: t('Combien de boutons manquent-ils ?'),
    eyelet: t('Combien de rivets / oeillets manquent-ils ?'),
    brokenZip: t('Combien y a-t-il de zips ?'),
    tornHoley: t('Combien y a-t-il de déchirures / trous ?'),
    tornHoleyLeatherGoods: t('Combien y a-t-il de déchirures / trous ?'),
    reinforcement: t('Combien de renforts sont nécessaires ?'),
    damagedElastic: t('Combien d’élastiques doivent-être changés ?'),
    damagedWhale: t('Combien de baleines doivent être changées ?'),
    adjustment_acce: t('Combien de parties nécessitent un ajustement ?'),
    scratched: t('Combien y-a-t-il d‘éraflures ?')
  };
};
var extractIdsFromTree = function extractIdsFromTree(tree) {
  var idList = [];
  tree.forEach(function (cloth) {
    if (!cloth.typesOfWork) return;
    cloth.typesOfWork.forEach(function (typeOfWork) {
      if (!typeOfWork.problems) return;
      typeOfWork.problems.forEach(function (problem) {
        if (!problem.locations) return;
        problem.locations.forEach(function (location) {
          idList.push(location.id);
          if (!location.parts) return;
          location.parts.forEach(function (part) {
            idList.push(part.id);
          });
        });
      });
    });
  });
  return idList;
};
var hasCommonDecoIds = function hasCommonDecoIds(order) {
  var commonDecoIds = [];
  // Ids for linens alterations not covered for package order
  var invalidLinensIds = ['12.deco-mai-1', '12.deco-mai-2', '12.deco-mai-3', '12.deco-mai-4', '12.deco-mai-5', '12.deco-mai-6', '12.deco-mai-7', '12.deco-mai-8', '12.deco-mai-9'];
  var hasInvalidLinensIds = order.clothes.some(function (cloth) {
    return cloth.items.some(function (item) {
      return invalidLinensIds.includes(item.id);
    });
  });

  // TypesOfWork not covered for package order
  var invalidTypesOfWork = ['embroidery', 'creation', 'transformation'];
  var hasInvalidTypeOfWork = order.clothes.some(function (cloth) {
    var _cloth$typesOfWork;
    return (_cloth$typesOfWork = cloth.typesOfWork) === null || _cloth$typesOfWork === void 0 ? void 0 : _cloth$typesOfWork.some(function (typeOfWork) {
      return invalidTypesOfWork.includes(typeOfWork);
    });
  });
  if (hasInvalidTypeOfWork || hasInvalidLinensIds) return false;
  order.clothes.forEach(function (cloth) {
    cloth.items.forEach(function (item) {
      if (item.id.includes('deco')) commonDecoIds.push(item.id);
    });
  });
  return commonDecoIds.length > 0;
};

// Every items ids of the order is in tree AND tree package
var hasCommonIdsAtHomeAndPackage = exports.hasCommonIdsAtHomeAndPackage = function hasCommonIdsAtHomeAndPackage(order) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (str) {
    return str;
  };
  if (!order) return null;
  var idsTree = extractIdsFromTree((0, _tree["default"])(t));
  var idsTreePackage = extractIdsFromTree((0, _treePackage["default"])(t));
  var otherHomeItemIds = (0, _tree.getOtherHomeItemIds)(order.pricingVersion);
  var otherPackageItemIds = (0, _treePackage.getOtherPackageItemIds)(order.pricingVersion);
  var isDecoValid = hasCommonDecoIds(order);
  var isAllClothesValid = order.clothes.every(function (cloth) {
    if (cloth.slug === 'deco') return true;
    return cloth.items.every(function (item) {
      return (idsTree.includes(item.id) || otherHomeItemIds.includes(item.id)) && (idsTreePackage.includes(item.id) || otherPackageItemIds.includes(item.id));
    });
  });

  // Order is considered valid if all the clothing items are valid AND the decoration is valid (if present).
  var isValidOrder = isAllClothesValid && (!order.clothes.some(function (cloth) {
    return cloth.slug === 'deco';
  }) || isDecoValid);
  return isValidOrder;
};

// At least one item id in the order is in tree and tree package and the other(s) in tree or tree package
var hasMixedIdsAtHomeAndPackage = exports.hasMixedIdsAtHomeAndPackage = function hasMixedIdsAtHomeAndPackage(order) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (str) {
    return str;
  };
  if (!order) return null;
  var foundCommonId = false;
  var foundUncommonId = false;
  var idsTree = extractIdsFromTree((0, _tree["default"])(t));
  var idsTreePackage = extractIdsFromTree((0, _treePackage["default"])(t));
  var isDecoValid = hasCommonDecoIds(order);
  order.clothes.forEach(function (cloth) {
    var hasCommonId = cloth.items.some(function (item) {
      return idsTree.includes(item.id) && idsTreePackage.includes(item.id);
    });
    var hasUncommonId = cloth.items.some(function (item) {
      return !idsTree.includes(item.id) || !idsTreePackage.includes(item.id);
    });
    if (hasCommonId || isDecoValid) foundCommonId = true;
    if (hasUncommonId) foundUncommonId = true;
  });
  return foundCommonId && foundUncommonId;
};